import React from "react";
import SectionCard from "../../ui/SectionCard";
import ClotTrackPicker from "../ClotTrackPicker";
import { clotOptions } from "../../../config/symptomsConfig";

const clotPickerOptions = clotOptions as unknown as Array<{
  value: string;
  label: string;
  dotSizePx?: number;
  description?: string;
  risk?: "normal" | "monitor" | "alert";
}>;

interface ClotsSectionCardProps {
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function ClotsSectionCard({
  value,
  onChange,
  disabled = false,
}: ClotsSectionCardProps) {
  return (
    <SectionCard
      title="Clots"
      description="If you noticed clots, choose the option that feels closest to what you observed."
    >
      <ClotTrackPicker
        options={clotPickerOptions}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </SectionCard>
  );
}
